import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators, AbstractControl, FormGroup  } from "@angular/forms";
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';
import { ExcelExportService } from 'src/app/Services/excel.service';
import { StorageService } from 'src/app/Services/storage.service';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { DateAdapter } from '@angular/material/core';
@Component({
  selector: 'g10-roster-dashboard-employee',
  templateUrl: './roster-dashboard-employee.component.html',
  styleUrls: ['./roster-dashboard-employee.component.css']
})
export class RosterDashboardEmployeeComponent implements OnInit {
  public filterForm:any;
  public minDate=new Date();
  public apiData:any=[];
  public tripData:any=[];
  public tableData:any={};
  public excelData:any = {};
  public showDownloadBtn:boolean=false;
  public showNoData:boolean=false;
  matFormSize = '13px';
  constructor(
    public api:ApiService,
    public storage:StorageService,
    private fb: FormBuilder,
    private com: CommonServices,
    public excel: ExcelExportService,
    private dateAdapter: DateAdapter<Date>,
    ) {
      this.dateAdapter.setLocale('en-GB'); //dd/MM/yyyy
    }

  ngOnInit(): void {
    this.loadFilterForm();
    this.getTripDetails();
  }
  loadFilterForm(){
    this.filterForm = this.fb.group({
      date: [this.minDate],
      transitMode:'Both'
      
    });
  }
  public checkError = (controlName: string, errorName: string) => {
    return this.filterForm.controls[controlName].hasError(errorName);
  }
  getTripDetails(){
    this.tableData={};
    let obj={
      "tripDate": new Date(new Date(this.filterForm.value.date).setHours(0,0,0,0)).getTime(),
      "default": true,
    }
    this.api.transportManagerRosterList(obj).then((res: any) => {
      if (res && res.status == 'success') {
        if (res.data && res.data.length > 0) {
          for(let a=0;a<res.data.length;a++){
            res.data[a].empInfo=res.data[a].empInfo.filter(e=>e.isAssigned);
          }
          this.showDownloadBtn = true;
          this.showNoData=false;
          if(this.filterForm.value.transitMode=='Pickup'){
            res.data=res.data.filter((e)=>e.transitMode=='Pickup')
          }else if(this.filterForm.value.transitMode=='Drop'){
            res.data=res.data.filter((e)=>e.transitMode=='Drop')
          }
          this.tripData=res.data;
          this.apiData=res.data;
          if(this.tripData.length>0){
            for(let i=0;i<this.tripData.length;i++){
              if(this.tripData[i].empInfo.length>0){
                for(let j=0;j<this.tripData[i].empInfo.length;j++){
                  if(this.tableData[this.tripData[i].empInfo[j].empRefID]){
                    if(this.tableData[this.tripData[i].empInfo[j].empRefID][this.tripData[i].transitMode]){
                      if(this.tableData[this.tripData[i].empInfo[j].empRefID][this.tripData[i].transitMode][this.tripData[i].shiftTimeStr]){
                        this.tableData[this.tripData[i].empInfo[j].empRefID][this.tripData[i].transitMode][this.tripData[i].shiftTimeStr].push(this.tripData[i]);
                      }else{
                        this.tableData[this.tripData[i].empInfo[j].empRefID][this.tripData[i].transitMode][this.tripData[i].shiftTimeStr]=[];
                        this.tableData[this.tripData[i].empInfo[j].empRefID][this.tripData[i].transitMode][this.tripData[i].shiftTimeStr].push(this.tripData[i]);
                      }
                    }else{
                      this.tableData[this.tripData[i].empInfo[j].empRefID][this.tripData[i].transitMode]={};
                      if(this.tableData[this.tripData[i].empInfo[j].empRefID][this.tripData[i].transitMode][this.tripData[i].shiftTimeStr]){
                        this.tableData[this.tripData[i].empInfo[j].empRefID][this.tripData[i].transitMode][this.tripData[i].shiftTimeStr].push(this.tripData[i]);
                      }else{
                        this.tableData[this.tripData[i].empInfo[j].empRefID][this.tripData[i].transitMode][this.tripData[i].shiftTimeStr]=[];
                        this.tableData[this.tripData[i].empInfo[j].empRefID][this.tripData[i].transitMode][this.tripData[i].shiftTimeStr].push(this.tripData[i]);
                      }
                    }
                  }else{
                    this.tableData[this.tripData[i].empInfo[j].empRefID]={};
                    if(this.tableData[this.tripData[i].empInfo[j].empRefID][this.tripData[i].transitMode]){
                      if(this.tableData[this.tripData[i].empInfo[j].empRefID][this.tripData[i].transitMode][this.tripData[i].shiftTimeStr]){
                        this.tableData[this.tripData[i].empInfo[j].empRefID][this.tripData[i].transitMode][this.tripData[i].shiftTimeStr].push(this.tripData[i]);
                      }else{
                        this.tableData[this.tripData[i].empInfo[j].empRefID][this.tripData[i].transitMode][this.tripData[i].shiftTimeStr]=[];
                        this.tableData[this.tripData[i].empInfo[j].empRefID][this.tripData[i].transitMode][this.tripData[i].shiftTimeStr].push(this.tripData[i]);
                      }
                    }else{
                      this.tableData[this.tripData[i].empInfo[j].empRefID][this.tripData[i].transitMode]={};
                      if(this.tableData[this.tripData[i].empInfo[j].empRefID][this.tripData[i].transitMode][this.tripData[i].shiftTimeStr]){
                        this.tableData[this.tripData[i].empInfo[j].empRefID][this.tripData[i].transitMode][this.tripData[i].shiftTimeStr].push(this.tripData[i]);
                      }else{
                        this.tableData[this.tripData[i].empInfo[j].empRefID][this.tripData[i].transitMode][this.tripData[i].shiftTimeStr]=[];
                        this.tableData[this.tripData[i].empInfo[j].empRefID][this.tripData[i].transitMode][this.tripData[i].shiftTimeStr].push(this.tripData[i]);
                      }
                    }
                  }
                }
              }
            }
          }
          let copyData=this.tableData;
          let refIds=Object.keys(copyData);
          for(let i=0;i<refIds.length;i++){
            let transMode=Object.keys(copyData[refIds[i]]);
            for(let j=0;j<transMode.length;j++){
              let eta=Object.keys(copyData[refIds[i]][transMode[j]]);
              let pickupCount=0;
              let dropCount=0;
              for(let k=0;k<eta.length;k++){
                if(copyData[refIds[i]]['Pickup']){
                  pickupCount=pickupCount+copyData[refIds[i]][transMode[j]][eta[k]].length;
                  this.tableData[refIds[i]][transMode[j]]['pickupCount']=pickupCount;
                }
                if(copyData[refIds[i]]['Drop']){
                  dropCount=dropCount+copyData[refIds[i]][transMode[j]][eta[k]].length;
                  this.tableData[refIds[i]][transMode[j]]['dropCount']=dropCount;
                }
              }
            }
          }
          let secondCopyData=this.tableData;
          let empInfo=Object.keys(secondCopyData);
          for(let a=0;a<empInfo.length;a++){
            let transMode=Object.keys(secondCopyData[refIds[a]]);
            for(let j=0;j<transMode.length;j++){
              if(secondCopyData[refIds[a]]['Pickup'] && !secondCopyData[refIds[a]]['Drop']){
                this.tableData[refIds[a]]['rowCount']=secondCopyData[refIds[a]]['Pickup']['pickupCount'];
              }
              if(!secondCopyData[refIds[a]]['Pickup']&& secondCopyData[refIds[a]]['Drop']){
                this.tableData[refIds[a]]['rowCount']=secondCopyData[refIds[a]]['Drop']['dropCount'];
              }
              if(secondCopyData[refIds[a]]['Pickup'] && secondCopyData[refIds[a]]['Drop']){
                
                this.tableData[refIds[a]]['rowCount']=secondCopyData[refIds[a]]['Pickup']['pickupCount'] + secondCopyData[refIds[a]]['Drop']['dropCount'];
              }
            }
          }
          if(Object.keys(this.tableData).length>0){
            this.showNoData=false;
            this.showDownloadBtn = true;
          }else{
            this.showNoData=true;
            this.showDownloadBtn = false;
          }
        }else{
          this.showNoData=true;
          this.showDownloadBtn = false;
        }
      }else{
        this.showNoData=true;
        this.showDownloadBtn = false;
      }
    }).catch((err) => {
      console.log(err);
    })
  }
  async exportToExcel() {
    let data:any = [];
    let refId=Object.keys(this.tableData);
    let sNo=1;
    for(let i=0;i<refId.length;i++){
      let transitModes=Object.keys(this.tableData[refId[i]]);
      if(refId[i] != 'rowCount'){
        for(let j=0;j<transitModes.length;j++){
          let eta=Object.keys(this.tableData[refId[i]][transitModes[j]]);
          for(let k=0;k<eta.length;k++){
            if(eta[k] != 'rowCount'){
              let loopData=this.tableData[refId[i]][transitModes[j]][eta[k]];
              for(let l=0;l<loopData.length;l++){
                for(let m=0;m<loopData[l].empInfo.length;m++){
                  if(refId[i]==loopData[l].empInfo[m].empRefID){
                    try{
                      let res:any = {
                        value: [
                          sNo++,
                          loopData[l]['empInfo'][m].empRefID ? String(loopData[l]['empInfo'][m].empRefID).toUpperCase()   : '---',
                          loopData[l]['empInfo'][m].name ? String(loopData[l]['empInfo'][m].name).charAt(0).toUpperCase() + String(loopData[l]['empInfo'][m].name).slice(1).toLowerCase() : '---',
                          loopData[l].transitMode ? loopData[l].transitMode : '---',                          
                          loopData[l].shiftTimeStr ? loopData[l].shiftTimeStr : '---',
                          loopData[l]['empInfo'][m].etaStr ? String(loopData[l]['empInfo'][m].etaStr).toUpperCase() : '---',
                          loopData[l].tripsheetID ? loopData[l].tripsheetID : '---',
                          loopData[l].vehRegNo ? loopData[l].vehRegNo : '---',
                          loopData[l].driverInfo['name'] ? String(loopData[l].driverInfo['name']).charAt(0).toUpperCase() + String(loopData[l].driverInfo['name']).slice(1).toLowerCase(): '---',
                          loopData[l].driverInfo['number'] ?  loopData[l].driverInfo['number'] : '---',
                          loopData[l]['empInfo'][m].address ?  String(loopData[l]['empInfo'][m].address).charAt(0).toUpperCase() + String(loopData[l]['empInfo'][m].address).slice(1).toLowerCase()  : '---',
                        ],
                      //  border: { bottom: { style: 'thin' }, right: { style: 'thin' } }
                      };
                      data.push(res);
                    }catch (err) {
                      console.log(err);
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    if (data.length > 0) {

      let rowCount = 2;
      let endCell = 'K';
      let customizedData:any = [];

      let titleRow:any = {
        value: ['Employee Planned Trips'],
        mergeCells: ["A1:K2"],
        font: {
          name: 'Corbel', family: 4, size: 16, bold: true,
          color: { argb: 'FFFFFFFF' },
        },
        alignment: {
          cell: "A1", value: { vertical: 'middle', horizontal: 'center' },
        },
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '966462AF' },
          bgColor: { argb: '966462AF' }
        },
      }

      customizedData.push(titleRow);
      rowCount = rowCount + 1;

      let subtitleRow = {
        value: [
          "Trip Date     : " + this.com.timestampToDate(new Date(this.filterForm.value.date).getTime(), 'DMY') 
        ],
        font: { name: 'Corbel', family: 4, size: 12 },
        mergeCells: ["A3:K3"],
      }
  
      customizedData.push(subtitleRow);
      rowCount = rowCount + 1;
      let headerRow =
      {
        value: ['S No', 'Employee ID', 'Employee name', 'Transit mode','Shift time', 'ETA', 'Trip sheet ID', 'Reg no','Driver name','Driver mobile','Address'],
        font: { bold: true },
        border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
      }
      customizedData.push(headerRow);

      customizedData = [...customizedData, ...data];

      const excelInfo = {
        customizedData: customizedData,
        data: {
          columWith: [{ colNo: 2, width: 20 }, { colNo: 3, width: 25 }, { colNo: 4, width: 15 }, { colNo: 5, width: 20 }, { colNo: 6, width: 25 }, { colNo: 7, width: 25 }, { colNo: 8, width: 25 }, { colNo: 9, width:  20 }, { colNo: 10, width:  25 }, { colNo: 11, width:  40 }]
        }
      };

      if (this.excelData['Employee_Planned_Trips'] == undefined) { this.excelData['Employee_Planned_Trips'] = {}; }

      this.excelData['Employee_Planned_Trips'] = excelInfo;
    }
    
    this.downloadExlReport();
  }
  downloadExlReport() {
    this.excel.generateExcel(this.excelData, 'Employee_Planned_Trips.xlsx');
  }
  removeDuplicates(arr) {
    let x=[];
    const unique = arr.filter(element => {
      const isDuplicate = x.includes(element.empRefID && element.etaStr);
    
      if (!isDuplicate) {
        x.push(element.empRefID && element.etaStr);
    
        return true;
      }else{
        return false;
      }
    });
    return unique;
  }
  formatShiftTime(value){
    let [h,m,s] = value.split(':');
    let shift=`${h}:${m}`;
    return shift;
  }
  changeToTitleCase(val){
    let x=val.charAt(0);
    if(typeof(x)==='string'){
      return x.toUpperCase() + val.slice(1);
    }else{
      return val;
    }
  }
  filterData(){
    this.excelData={};
    this.getTripDetails();
  }
}
